import { ErrorCode } from '@fluenceur/types';

/**
 * The API refused a subscription because nobody agreed to the success-fee terms.
 *
 * Read in two places, and they answer it together: the billing mutations stay
 * silent on it, and the pricing page offers the acceptance instead. It is the
 * only refusal on that path a merchant can clear without leaving the page, so
 * announcing it as an error would hand a dead end to someone one click from the
 * way out.
 */
export function isSuccessFeeTermsRefusal(error: unknown): boolean {
  const code = (error as { response?: { data?: { code?: unknown } } } | null)?.response?.data?.code;

  return code === ErrorCode.E_SUCCESS_FEE_TERMS_NOT_ACCEPTED;
}
